module.exports = __webpack_public_path__ + "img/36.01fad992.png";